import React from 'react';

// 全局错误边界：捕获渲染期异常并显示, 避免生产构建下整页白屏无提示
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('App crashed:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '24px', fontFamily: 'sans-serif', color: '#c0392b' }}>
          <h2>页面加载出错</h2>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#fdecea', padding: '12px', borderRadius: '6px' }}>
            {this.state.error && (this.state.error.stack || this.state.error.toString())}
          </pre>
          <button onClick={() => window.location.reload()} style={{ marginTop: '12px', padding: '8px 16px' }}>
            重新加载
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
